var React = require('react');

function XIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m178.57 127.15 111.7-127.15h-26.46l-97.03 110.38-77.44-110.38h-89.34l117.13 166.93-117.13 133.32h26.46l102.4-116.59 81.8 116.59h89.34m-263.99-280.71h40.65l187.13 262.13h-40.66","fillRule":"nonzero","transform":"matrix(.9 0 0 .9 145 64.8875)"}));
}

XIcon.defaultProps = {"viewBox":"145 64.89 270 270.23"};

module.exports = XIcon;

XIcon.default = XIcon;
